import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel";
import { getPosts, getSettings } from "@/lib/api";
import { categoryStyle } from "@/lib/constants";

export default function FeaturedSlider() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        getSettings()
            .then((s) =>
                getPosts(
                    "featured",
                    s.countdown_enabled ? { withinHours: 72 } : {},
                ),
            )
            .then(setPosts)
            .catch(() => setPosts([]));
    }, []);

    return (
        <section
            className="px-4 md:px-8 lg:px-12 mt-12"
            data-testid="featured-section"
            id="featured-slider"
        >
            <h2 className="section-title mb-6" data-testid="featured-title">
                Featured
            </h2>
            {posts.length === 0 ? (
                <p
                    className="font-sofia text-[#1B1B1B]/60 italic"
                    data-testid="featured-empty"
                >
                    No featured posts in the last 72 hours. Visit{" "}
                    <a href="/categories" className="text-[#E63B26] underline">
                        Categories
                    </a>{" "}
                    for the full archive.
                </p>
            ) : (
            <div className="relative" data-testid="featured-slider">
                <Carousel
                    opts={{ align: "start", loop: true }}
                    className="w-full"
                    data-testid="featured-carousel"
                >
                    <CarouselContent className="-ml-4">
                        {posts.map((post) => (
                            <CarouselItem
                                key={post.id}
                                className="pl-4 md:basis-1/2 lg:basis-1/3"
                                data-testid={`featured-slide-${post.slug}`}
                            >
                                <Link
                                    to={`/post/${post.slug}`}
                                    className="post-card relative block overflow-hidden bg-[#1B1B1B]"
                                    data-testid={`featured-card-link-${post.slug}`}
                                >
                                    <div className="relative aspect-[3/2] overflow-hidden">
                                        <img
                                            src={post.image_url}
                                            alt={post.title}
                                            className="post-card-image absolute inset-0 w-full h-full object-cover"
                                            loading="lazy"
                                        />
                                        <span
                                            className="badge-category absolute top-3 left-3 z-10"
                                            style={categoryStyle(post.category)}
                                        >
                                            {post.category}
                                        </span>
                                        <div className="post-card-caption">
                                            {post.title.length > 60
                                                ? post.title.slice(0, 57) +
                                                  "..."
                                                : post.title}
                                        </div>
                                    </div>
                                </Link>
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious
                        className="left-2 bg-white border-none h-12 w-12 rounded-none shadow"
                        data-testid="featured-prev"
                    />
                    <CarouselNext
                        className="right-2 bg-[#1B1B1B] text-white border-none h-12 w-12 rounded-none hover:bg-[#E63B26] hover:text-white"
                        data-testid="featured-next"
                    />
                </Carousel>
            </div>
            )}
        </section>
    );
}
